import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import TextField from "@mui/material/TextField";
import { Preloader } from "../common/index.js";
import ReactInputMask from "../../ReactInputMask/index.js";
import AddressInput_styles from "./AddressInput.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function TextFieldMasked_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else TextFieldMasked_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
function _object_without_properties(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys, key, i;
    if ("u" > typeof Reflect && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (!(excluded.indexOf(key) >= 0)) {
                if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
            }
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (null == source) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (!(excluded.indexOf(key) >= 0)) {
            if (Object.prototype.propertyIsEnumerable.call(source, key)) target[key] = source[key];
        }
    }
    return target;
}
const TextFieldMasked = (t0)=>{
    const $ = c(50);
    let InputLabelProps;
    let InputProps;
    let error;
    let helperText;
    let inputProps;
    let loading;
    let mask;
    let name;
    let onChange;
    let rest;
    if ($[0] !== t0) {
        ({ mask, name, error, helperText, loading, onChange, inputProps, InputProps, InputLabelProps } = t0), rest = _object_without_properties(t0, [
            "mask",
            "name",
            "error",
            "helperText",
            "loading",
            "onChange",
            "inputProps",
            "InputProps",
            "InputLabelProps"
        ]);
        $[0] = t0;
        $[1] = InputLabelProps;
        $[2] = InputProps;
        $[3] = error;
        $[4] = helperText;
        $[5] = inputProps;
        $[6] = loading;
        $[7] = mask;
        $[8] = name;
        $[9] = onChange;
        $[10] = rest;
    } else {
        InputLabelProps = $[1];
        InputProps = $[2];
        error = $[3];
        helperText = $[4];
        inputProps = $[5];
        loading = $[6];
        mask = $[7];
        name = $[8];
        onChange = $[9];
        rest = $[10];
    }
    const { classes } = AddressInput_styles();
    let inputPropsRest;
    if ($[11] !== inputProps) {
        const { value } = inputProps, t1 = _object_without_properties(inputProps, [
            "value"
        ]);
        inputPropsRest = t1;
        $[11] = inputProps;
        $[12] = inputPropsRest;
    } else inputPropsRest = $[12];
    let t1;
    if ($[13] !== inputProps || $[14] !== onChange) {
        t1 = (e)=>{
            var _inputProps_onChange;
            onChange(e, e.target.value);
            null == (_inputProps_onChange = inputProps.onChange) || _inputProps_onChange.call(inputProps, e);
        };
        $[13] = inputProps;
        $[14] = onChange;
        $[15] = t1;
    } else t1 = $[15];
    const handleChange = t1;
    const t2 = null == inputProps ? void 0 : inputProps.onFocus;
    const t3 = null == inputProps ? void 0 : inputProps.onBlur;
    const t4 = null == inputProps ? void 0 : inputProps.onMouseDown;
    const t5 = null == inputProps ? void 0 : inputProps.onKeyDown;
    const t6 = null == inputProps ? void 0 : inputProps.ref;
    let t7;
    if ($[16] !== classes.inputRoot) {
        t7 = {
            root: classes.inputRoot
        };
        $[16] = classes.inputRoot;
        $[17] = t7;
    } else t7 = $[17];
    let t8;
    if ($[18] !== inputPropsRest) {
        t8 = _object_spread({}, inputPropsRest);
        $[18] = inputPropsRest;
        $[19] = t8;
    } else t8 = $[19];
    let t9;
    if ($[20] !== loading) {
        t9 = loading ? {
            endAdornment: /*#__PURE__*/ jsx(Preloader, {})
        } : {};
        $[20] = loading;
        $[21] = t9;
    } else t9 = $[21];
    let t10;
    if ($[22] !== InputProps || $[23] !== t9) {
        t10 = _object_spread({}, InputProps, t9);
        $[22] = InputProps;
        $[23] = t9;
        $[24] = t10;
    } else t10 = $[24];
    let t11;
    if ($[25] !== InputLabelProps) {
        t11 = _object_spread({}, InputLabelProps);
        $[25] = InputLabelProps;
        $[26] = t11;
    } else t11 = $[26];
    let t12;
    if ($[27] !== t10 || $[28] !== t11 || $[29] !== t8) {
        t12 = {
            htmlInput: t8,
            input: t10,
            inputLabel: t11
        };
        $[27] = t10;
        $[28] = t11;
        $[29] = t8;
        $[30] = t12;
    } else t12 = $[30];
    let t13;
    if ($[31] !== error || $[32] !== helperText || $[33] !== name || $[34] !== rest || $[35] !== t12 || $[36] !== t6 || $[37] !== t7) {
        t13 = /*#__PURE__*/ jsx(TextField, _object_spread_props(_object_spread({}, rest), {
            inputRef: t6,
            name: name,
            classes: t7,
            autoComplete: "off",
            variant: "outlined",
            fullWidth: true,
            error: error,
            helperText: helperText,
            placeholder: rest.placeholder,
            slotProps: t12
        }));
        $[31] = error;
        $[32] = helperText;
        $[33] = name;
        $[34] = rest;
        $[35] = t12;
        $[36] = t6;
        $[37] = t7;
        $[38] = t13;
    } else t13 = $[38];
    let t14;
    if ($[39] !== handleChange || $[40] !== inputProps.value || $[41] !== mask || $[42] !== name || $[43] !== rest.disabled || $[44] !== t13 || $[45] !== t2 || $[46] !== t3 || $[47] !== t4 || $[48] !== t5) {
        t14 = /*#__PURE__*/ jsx(ReactInputMask, {
            value: inputProps.value,
            onFocus: t2,
            onBlur: t3,
            onMouseDown: t4,
            onKeyDown: t5,
            mask: mask,
            name: name,
            onChange: handleChange,
            disabled: rest.disabled,
            children: t13
        });
        $[39] = handleChange;
        $[40] = inputProps.value;
        $[41] = mask;
        $[42] = name;
        $[43] = rest.disabled;
        $[44] = t13;
        $[45] = t2;
        $[46] = t3;
        $[47] = t4;
        $[48] = t5;
        $[49] = t14;
    } else t14 = $[49];
    return t14;
};
export { TextFieldMasked };
